import { Button, Icon, Modal, addToast } from '@octano/global-ui';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';

import { TranslationsKeys } from '../../../locales/translations';
import {
  downloadFromBlob,
  readErrorMessageFromBlob,
} from '../../../utils/blob';
import { downloadFailureDetail } from '../api';

interface Props {
  isOpen: boolean;
  fileUploadFailureId: number | string | null;
  onClose: () => void;
}

export default function UploadFailureModal({
  isOpen,
  fileUploadFailureId,
  onClose,
}: Props) {
  const { t } = useTranslation(
    TranslationsKeys.ADMISSION_AND_ENROLLMENTS_BENEFIT_ALLOCATION,
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDownload = useCallback(async () => {
    if (!fileUploadFailureId) {
      return;
    }
    setIsLoading(true);
    const res = await downloadFailureDetail(fileUploadFailureId);
    if (res.error) {
      const message = await readErrorMessageFromBlob(res.error.data);
      addToast({
        icon: 'error',
        color: 'danger',
        text: message ?? t('errors.generic'),
      });
    } else {
      const blob = new Blob([res.data], { type: 'vnd.ms-excel' });
      downloadFromBlob(blob, 'Errores_Asignacion_Beneficios.xlsx');
    }
    setIsLoading(false);
  }, [fileUploadFailureId, t]);

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      <Container fluid>
        <Row>
          <Col xs={12} className="text-center pt-3">
            <Icon name="warning" color="secondary" size="50px" />
          </Col>
        </Row>
        <p className="text-dark fs-20 mt-4 mb-3 text-center">
          {t('errors.title')}
        </p>
        <p className="text-dark fs-16 mb-4 text-center">
          {t('errors.invalidData')}
        </p>
        <Row>
          <Col xs={12} sm={6} className="pb-2">
            <Button
              onClick={onClose}
              text={t('errors.back')}
              outlined
              fullwidth
              disabled={isLoading}
            />
          </Col>
          <Col xs={12} sm={6} className="pb-2">
            <Button
              onClick={handleDownload}
              text={t('errors.downloadDetail')}
              fullwidth
              loading={isLoading}
            />
          </Col>
        </Row>
      </Container>
    </Modal>
  );
}
